import ReservationsPanel from "./ReservationsPanel";

export default ReservationsPanel;